import { render, staticRenderFns } from "./PcoCircuitoFichasTecnicasComponent.vue?vue&type=template&id=e0132ffa&scoped=true"
import script from "./PcoCircuitoFichasTecnicasComponent.vue?vue&type=script&lang=js"
export * from "./PcoCircuitoFichasTecnicasComponent.vue?vue&type=script&lang=js"
import style0 from "./PcoCircuitoFichasTecnicasComponent.vue?vue&type=style&index=0&id=e0132ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0132ffa",
  null
  
)

export default component.exports